import { render, staticRenderFns } from "./AddVersionModal.vue?vue&type=template&id=eab97a16&scoped=true"
import script from "./AddVersionModal.vue?vue&type=script&lang=js"
export * from "./AddVersionModal.vue?vue&type=script&lang=js"
import style0 from "./AddVersionModal.vue?vue&type=style&index=0&id=eab97a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab97a16",
  null
  
)

export default component.exports